import { useQuery } from '@apollo/react-hooks'
import gql from 'graphql-tag'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import {
  getUntypedJoinUrlNoNav,
  getWhitelabelBranding,
} from 'main/components/common/AuthModal/ssoNavigation'
import Loader from 'main/components/common/Loader'
import Page from 'main/components/common/Page'
import { maybeUserHomePath } from 'main/routes'
import { buildTracking, extractParams, hasUser } from 'main/util/ssoRouting'
import { UserSignUpSource } from 'main/util/user'

import { Container, ContentContainer } from './Join.styles'

const NETWORK_QUERY = gql`
  query NetworkQuery($networkId: String!) {
    network(id: $networkId) {
      id
      name
      autoMigrateCcms
      whitelabelOptions
    }
  }
`

export default function JoinSSO(
  props: RouteComponentProps<{
    networkId?: string
  }>,
) {
  const {
    history,
    match: {
      params: { networkId },
    },
  } = props

  React.useEffect(() => {
    if (hasUser()) {
      redirectHome()
    }
  }, [])

  useQuery(NETWORK_QUERY, {
    variables: { networkId },
    onCompleted: data => redirectToSSO(data?.network),
  })

  return (
    <Page headerParams={{ onlyShowLogo: true, disableLogoLink: true }} hideFooter>
      <Container>
        <ContentContainer>
          <Loader />
        </ContentContainer>
      </Container>
    </Page>
  )

  function redirectHome() {
    history.replace(maybeUserHomePath())
  }

  function redirectToSSO(network: any) {
    const { type, schoolId, externalSchoolId, sessionId } = extractParams()

    const tracking = buildTracking(
      type,
      [
        UserSignUpSource.DirectorJoinPage,
        UserSignUpSource.ParentJoinPage,
        UserSignUpSource.JoinPage,
      ],
      ['completed_director_sign_up', 'completed_parent_sign_up', 'completed_unknown_sign_up'],
      {
        schoolId,
        externalSchoolId,
        sessionId,
      },
    )

    const joinUrlSSO = getUntypedJoinUrlNoNav(
      tracking,
      {
        ...getWhitelabelBranding(network),
        type: 'director',
        networkId,
        bnd: {
          networkAutoMigrateCcms: network?.autoMigrateCcms,
        },
      },
      type,
    )

    window.location.replace(joinUrlSSO)
  }
}
